const CDN = "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/intensive-english";

export const COURSE_HEADER_ICONS = {
  stack: `${CDN}/python-icon.avif`,
  java: `${CDN}/java-icon.avif`,
};
